import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TranslateModule } from '@ngx-translate/core';

import { SidebarComponent } from './sidebar/sidebar.component';
import { MylayoutComponent } from './mylayout.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { BodyComponent } from './body/body.component';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '../core/pipes/search-filter.pipe';

@NgModule({
  declarations: [
    MylayoutComponent,
    SidebarComponent,
    TopbarComponent,
    FooterComponent,
    BodyComponent,
    SearchFilterPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    TranslateModule,
    FormsModule,
    
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class MylayoutModule { }
